import type { SVGProps } from 'react';

/** Two filled sparkles, matching the AI-chat reference mark. */
export function AiIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M9.5 5c.6 5.4 2.1 7 7.5 8-5.4 1-6.9 2.6-7.5 8-.7-5.4-2.2-7-7.5-8 5.3-1 6.8-2.6 7.5-8ZM18 2c.4 3.2 1.4 4.3 4.5 5-3.1.7-4.1 1.8-4.5 5-.4-3.2-1.4-4.3-4.5-5C16.6 6.3 17.6 5.2 18 2Z" />
    </svg>
  );
}
